import '../App.css';
import "./Reputation.css";
import { useState, useEffect, useContext } from 'react';

import * as fcl from '@onflow/fcl';
import * as t from '@onflow/types';

import FlowContext from '../context/FlowContext.js';

import { getReputationsScript, getIdentityTx, giveReputationTx } from '../cadence/reputations.js';
import artworkcard from "./images/artworkcard.png";
import educatorcard from "./images/educatorcard.png";
import technicalcard from "./images/technicalcard.png";
import treasurycard from "./images/treasurycard.png";

// https://play.onflow.org/614ca17c-5aa7-4677-900f-0df3ed49da38?type=account&id=0

const Reputation = () => {
    const flow = useContext(FlowContext);
    const [reputations, setReputations] = useState({});
    const [loading, setLoading] = useState('');
    const [ready, setReady] = useState(false);

    const getReputations = async () => {
        try {
            const result = await fcl.send([
                fcl.script(getReputationsScript),
                fcl.args([
                    fcl.arg(flow.user.addr, t.Address)
                ])
            ]).then(fcl.decode);

            console.log("REPUTATIONS", result);
            setReputations(result);
            setReady(true);
        } catch (e) {
            console.log(e);
            setReady(false);
            initializeIdentity();
        }
    }

    const initializeIdentity = async () => {
        const transactionId = await fcl.send([
            fcl.transaction(getIdentityTx),
            fcl.proposer(fcl.authz),
            fcl.payer(fcl.authz),
            fcl.authorizations([fcl.authz]),
            fcl.limit(999)
        ]).then(fcl.decode);

        setLoading("Please wait a few moments while your account is set up.")
        await fcl.tx(transactionId).onceSealed();
        setLoading('');
        getReputations();
    }

    // can only be called by my admin account anyway
    const giveReputation = async () => {
        const transactionId = await fcl.send([
            fcl.transaction(giveReputationTx),
            fcl.args([
                fcl.arg(flow.user.addr, t.Address),
                fcl.arg("10.0", t.UFix64),
                fcl.arg(1, t.UInt8)
            ]),
            fcl.proposer(fcl.authz),
            fcl.payer(fcl.authz),
            fcl.authorizations([fcl.authz]),
            fcl.limit(999)
        ]).then(fcl.decode);

        console.log("Give reputation tx", transactionId);
    }

    useEffect(() => {
        if (flow.user && flow.user.loggedIn) {
            try {
                getReputations();
            } catch (e) {
                console.log(e);
            }
        }
    }, [flow.user])

    return (
        <div className="Reputation">

            {flow.user.loggedIn && ready
                ?
                <div className="list">
                    <div className="centered">
                        <img src={educatorcard} alt="education card" />
                        <h1>{reputations[0] ? parseFloat(reputations[0]).toFixed(2) : 0}</h1>
                    </div>
                    <div className="centered">
                        <img src={treasurycard} alt="treasury card" />
                        <h1>{reputations[1] ? parseFloat(reputations[1]).toFixed(2) : 0}</h1>
                    </div>
                    <div className="centered">
                        <img src={technicalcard} alt="technical card" />
                        <h1>{reputations[2] ? parseFloat(reputations[2]).toFixed(2) : 0}</h1>
                    </div>
                    <div className="centered">
                        <img src={artworkcard} alt="artwork card" />
                        <h1>{reputations[3] ? parseFloat(reputations[3]).toFixed(2) : 0}</h1>
                    </div>
                </div>
                : null}

            {loading !== '' ? <h1 className="loading">{loading}</h1> : null}
        </div>
    )
}

export default Reputation;
